import React from 'react';
import PropTypes from 'prop-types';
import { Elements, useStripe, useElements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

// UTILITY
import bugsnagClient from '@/utility/bugsnagClient';

const locale = 'en';
const stripeKey = process.env.REACT_APP_STRIPE_PUBLIC_KEY;
let stripePromise;
let stripeError = null;

const getStripe = (refresh = false) => {
  if (!stripePromise || refresh) {
    stripePromise = loadStripe(stripeKey).then(
      stripe => {
        stripeError = null;

        return stripe;
      },
      err => {
        stripeError = err;

        bugsnagClient.notify(err);
      },
    );
  }

  return stripePromise;
};

stripePromise = getStripe(!!stripeError);

const StripeElements = ({ component: Component, ...props }) => {
  const stripe = useStripe();
  const elements = useElements();
  const error = !stripe && stripeError ? stripeError : null;

  return <Component {...props} stripe={stripe} stripeError={error} elements={elements} />;
};

const withStripeElements = Component => props => {
  // eslint-disable-next-line
  const withClientSecret = !!props.clientSecret;
  // eslint-disable-next-line
  const options = props.options || {};

  if (withClientSecret) {
    const opts = {
      // eslint-disable-next-line
      clientSecret: props.clientSecret,
      locale,
      ...options,
    };

    return (
      !!withClientSecret && (
        <Elements stripe={stripePromise} key={locale} options={opts}>
          <StripeElements {...props} component={Component} />
        </Elements>
      )
    );
  }

  return (
    <Elements stripe={stripePromise} key={locale} options={{ locale, ...options }}>
      <StripeElements {...props} component={Component} />
    </Elements>
  );
};

StripeElements.propTypes = {
  locale: PropTypes.string,
  component: PropTypes.any.isRequired,
  clientSecret: PropTypes.string,
  options: PropTypes.object,
};

export default withStripeElements;
